import { render } from "./KP_PICKER.vue?vue&type=template&id=392ef51e&ts=true"
import script from "./KP_PICKER.vue?vue&type=script&lang=ts"
export * from "./KP_PICKER.vue?vue&type=script&lang=ts"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__